import { compact } from 'lodash'
import React, { useMemo } from 'react'
import {
  getFullNameFromPerson,
  getLinkedinUrlFromPerson,
  getPersonFromPosition,
  getRoleFromPosition,
} from 'scenes/Dashboard/data/people/selectors'
import { Position } from 'scenes/Dashboard/data/people/types'

import { Typography } from '@mui/material'

export type OrganizationDetailsPositionDataProps = {
  className?: string
  style?: React.CSSProperties
  positions: Position[]
}

function useOrganizationDetailsPositionData(positions: Position[]) {
  return useMemo(
    () =>
      compact(
        positions.map((position) => {
          const person = getPersonFromPosition(position)
          if (!person) {
            return undefined
          }
          const role = getRoleFromPosition(position)
          const linkedinUrl = getLinkedinUrlFromPerson(person)
          const fullName = getFullNameFromPerson(person)
          return {
            role: role || '',
            fullName,
            linkedinUrl,
          }
        })
      ),
    [positions]
  )
}

export const OrganizationDetailsPositionData = React.memo(
  ({ className, style, positions }: OrganizationDetailsPositionDataProps) => {
    const currentPositions = useOrganizationDetailsPositionData(positions)
    return (
      <div className={className} style={style}>
        {currentPositions.map(({ fullName, linkedinUrl, role }) => (
          <Typography key={linkedinUrl} variant="body2" className={className}>
            {`${fullName} - ${role}: `}
            <a target="_blank" href={linkedinUrl} rel="noopener noreferrer">
              {linkedinUrl}
            </a>
          </Typography>
        ))}
      </div>
    )
  }
)

OrganizationDetailsPositionData.displayName = 'OrganiationDetailsPositionData'
